import React, { useState } from "react";
import Button from "../../../../../common/Button";
import { ChevronUpIcon, ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
  adultNonPrescriptionOralAntihistamines,
  adultPrescriptionAddOnIntranasalDecongestants,
  adultPrescriptionAddOnOralDecongestants,
  adultPrescriptionCombination,
  adultPrescriptionIntranasalCorticosteroids,
  adultPrescriptionOralAntihistamines,
  paediatricNonPrescriptionOralAntihistamines,
  paediatricPrescriptionAddOnIntranasalDecongestants,
  paediatricPrescriptionAddOnOralDecongestants,
  paediatricPrescriptionCombination,
  paediatricPrescriptionIntranasalCorticosteroids,
  paediatricPrescriptionOralAntihistamines,
} from "../../treatment/pharmacological/data";
import { ReactSVG } from "react-svg";
import NewToolTip from "../../../../../common/New-ToolTip";

const titles = {
  alternativeFirstLineCombination: "Alternative First Line Therapy",
  firstLineIntranasalCorticosteroids: "First Line Therapy",
  firstLineOralAntihistamines: "First Line Therapy",
  stepUpIntranasalCorticosteroids: "Step Up Therapy",
  stepUpCombination: "Step Up Therapy",
  addOnTherapyOralDecongestants: "Add On Therapy",
  addOnTherapyIntranasalDecongestants: "Add On Therapy",
  addOnTherapyOralAntihistamines: "Add On Therapy",

};

const InformationStep = ({
  onClose,
  currentStep,
  type,
  create,
  onNext,
  onMedicineClick,
  activeButton,
  setActiveButton,
}) => {
  const findTitle = () => titles[type] || "";
  const [showPrescribingDetails, setShowPrescribingDetails] = useState(false);

  const ButtonComponent = ({ isActive, children, onClick }) => {
    const baseClasses =
      "px-4 py-3.5 flex items-center justify-center text-body-md font-medium rounded-[4px]";
    const activeClasses =
      "bg-white border-gray-100 border-[1px] border-b-[1px] border-b-white text-REELTeal";
    const inactiveClasses =
      "bg-gray-20 text-gray-600 border-gray-100 border-b-[1px]";

    return (
      <button
        className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
        aria-pressed={isActive}
        onClick={onClick}
      >
        {children}
      </button>
    );
  };

  const renderPaediatricOralAntihistaminesContent = () => (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Oral Antihistamines (2nd Generation)
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg border-[2px] border-gray-200 text-gray-800 font-semibold p-3">
          {paediatricPrescriptionOralAntihistamines.type}
        </p>
        {paediatricPrescriptionOralAntihistamines.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <p className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              {med.name}{med.dose}
            </p>
            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose?.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white border-b-[1px] cursor-pointer border-b-[#E0E0E0] hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                </div>
              </div>
            ))}
          </div>
        ))}
        <p className="text-body-lg border-[2px] border-gray-200 text-gray-800 font-semibold p-3">
          {paediatricNonPrescriptionOralAntihistamines.type}
        </p>
        {paediatricNonPrescriptionOralAntihistamines.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <p className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              {med.name}{med.dose}
            </p>
            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose?.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white border-b-[1px] cursor-pointer border-b-[#E0E0E0] hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  const renderAdultOralAntihistaminesContent = () => (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Oral Antihistamines (2nd Generation)
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 border-[2px] border-gray-200 font-semibold p-3">
          {adultPrescriptionOralAntihistamines.type}
        </p>
        {adultPrescriptionOralAntihistamines.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <p className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              {med.name}{med.dose}
            </p>
            {med.dosages.map((dose, index) => (
              <div
                onClick={() => {
                  onMedicineClick(dose?.medicine);
                }}
                key={index}
                className="grid grid-cols-2 p-2.5 bg-white border-b-[1px] cursor-pointer border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                </div>
              </div>
            ))}
          </div>
        ))}
        <p className="text-body-lg text-gray-800 border-[2px] border-gray-200 font-semibold p-3">
          {adultNonPrescriptionOralAntihistamines.type}
        </p>
        {adultNonPrescriptionOralAntihistamines.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <p className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              {med.name}{med.dose}
            </p>
            {med.dosages.map((dose, index) => (
              <div
                onClick={() => {
                  onMedicineClick(dose?.medicine);
                }}
                key={index}
                className="grid grid-cols-2 p-2.5 bg-white border-b-[1px] cursor-pointer border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  const renderAdultSteroidsContent = () => (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Intranasal Corticosteroids
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {adultPrescriptionIntranasalCorticosteroids.type}
        </p>
        {adultPrescriptionIntranasalCorticosteroids.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <div className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              <p>{med.name}{med.dose}</p>
              <p className="text-sm font-normal">{med.subname}</p>
            </div>
            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                  {dose.cps && (
                    <p className="flex">
                      CPS Reference: &nbsp;
                      <ReactSVG
                        src="/icons/information-dark.svg"
                        className="w-5"
                        data-tooltip-id={dose.cps}
                      />
                      <NewToolTip
                        id={dose.cps}
                        render={() => (
                          <div className="bg-gray-10 max-w-[300px] text-teal-300 text-body-sm p-2 whitespace-pre-line">
                            {dose.cps}
                          </div>
                        )}
                      />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  const renderPaediatricSteroidsContent = () => (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Intranasal Corticosteroids
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {paediatricPrescriptionIntranasalCorticosteroids.type}
        </p>
        {paediatricPrescriptionIntranasalCorticosteroids.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <div className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              <p>{med.name}{med.dose}</p>
              <p className="text-sm font-normal">{med.subname}</p>
            </div>

            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                  {dose.cps && (
                    <p className="flex">
                      CPS Reference: &nbsp;
                      <ReactSVG
                        src="/icons/information-dark.svg"
                        className="w-5"
                        data-tooltip-id={dose.cps}
                      />
                      <NewToolTip
                        id={dose.cps}
                        render={() => (
                          <div className="bg-gray-10 max-w-[300px] text-teal-300 text-body-sm p-2 whitespace-pre-line">
                            {dose.cps}
                          </div>
                        )}
                      />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  const renderPaediatricCombinationContent = () => (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Intranasal Antihistamine/Corticosteroid Combinations
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {paediatricPrescriptionCombination.type}
        </p>
        {paediatricPrescriptionCombination.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <p className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              {med.name}{med.dose}
            </p>
            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <p className="text-body-sm text-gray-800">{dose.dosage}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  const renderAdultCombinationContent = () => (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Intranasal Antihistamine/Corticosteroid Combinations
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {adultPrescriptionCombination.type}
        </p>
        {adultPrescriptionCombination.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <p className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              {med.name}{med.dose}
            </p>
            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <p className="text-body-sm text-gray-800">{dose.dosage}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );

  const renderAdultAddOnOralDecongestantContent = () => {
    if (!adultPrescriptionAddOnOralDecongestants.medications?.length) return null;
    return (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Oral Decongestants
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {adultPrescriptionAddOnOralDecongestants.type}
        </p>
        {adultPrescriptionAddOnOralDecongestants.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <div className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              <p>{med.name}{med.dose}</p>
              <p className="text-sm font-normal">{med.subname}</p>
            </div>

            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                  {dose.cps && (
                    <p className="flex">
                      CPS Reference: &nbsp;
                      <ReactSVG
                        src="/icons/information-dark.svg"
                        className="w-5"
                        data-tooltip-id={dose.cps}
                      />
                      <NewToolTip
                        id={dose.cps}
                        render={() => (
                          <div className="bg-gray-10 max-w-[300px] text-teal-300 text-body-sm p-2 whitespace-pre-line">
                            {dose.cps}
                          </div>
                        )}
                      />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
    );
  };

  const renderPaediatricAddOnOralDecongestantContent = () => {
    if (!paediatricPrescriptionAddOnOralDecongestants.medications?.length) return null;
    return (
    <div className="flex flex-col">
      <p className="text-body-2xl text-REELTeal font-semibold px-3 py-5 border-b-[1px] border-gray-100 ">
        Oral Decongestants
      </p>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {paediatricPrescriptionAddOnOralDecongestants.type}
        </p>
        {paediatricPrescriptionAddOnOralDecongestants.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <div className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              <p>{med.name}{med.dose}</p>
              <p className="text-sm font-normal">{med.subname}</p>
            </div>

            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                  {dose.cps && (
                    <p className="flex">
                      CPS Reference: &nbsp;
                      <ReactSVG
                        src="/icons/information-dark.svg"
                        className="w-5"
                        data-tooltip-id={dose.cps}
                      />
                      <NewToolTip
                        id={dose.cps}
                        render={() => (
                          <div className="bg-gray-10 max-w-[300px] text-teal-300 text-body-sm p-2 whitespace-pre-line">
                            {dose.cps}
                          </div>
                        )}
                      />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
    );
  };

  const renderAdultAddOnIntranasalDecongestantContent = () => {
    if (!adultPrescriptionAddOnIntranasalDecongestants.medications?.length) return null;
    return (
    <div className="flex flex-col">
      <div className="px-3 py-5 border-b-[1px] border-gray-100 ">
        <p className="text-body-2xl text-REELTeal font-semibold "> Intranasal Decongestants</p>
        <p className="mt-2.5 text-body-sm">{`Some products may not be indicated for children < 12 yrs`}</p>
      </div>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {adultPrescriptionAddOnIntranasalDecongestants.type}
        </p>
        {adultPrescriptionAddOnIntranasalDecongestants.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <div className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              <p>{med.name}{med.dose}</p>
              <p className="text-sm font-normal">{med.subname}</p>
            </div>

            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine, med?.subname);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                  {dose.cps && (
                    <p className="flex">
                      CPS Reference: &nbsp;
                      <ReactSVG
                        src="/icons/information-dark.svg"
                        className="w-5"
                        data-tooltip-id={dose.cps}
                      />
                      <NewToolTip
                        id={dose.cps}
                        render={() => (
                          <div className="bg-gray-10 max-w-[300px] text-teal-300 text-body-sm p-2 whitespace-pre-line">
                            {dose.cps}
                          </div>
                        )}
                      />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
    );
  };

  const renderPaediatricAddOnIntranasalDecongestantContent = () => {
    if (!paediatricPrescriptionAddOnIntranasalDecongestants.medications?.length) return null;
    return (
    <div className="flex flex-col">
      <div className="px-3 py-5 border-b-[1px] border-gray-100 ">
        <p className="text-body-2xl text-REELTeal font-semibold "> Intranasal Decongestants</p>
        <p className="mt-2.5 text-body-sm">{`Some products may not be indicated for children < 12 yrs`}</p>
      </div>
      <div className="flex flex-col">
        <p className="text-body-lg text-gray-800 font-semibold p-3">
          {paediatricPrescriptionAddOnIntranasalDecongestants.type}
        </p>
        {paediatricPrescriptionAddOnIntranasalDecongestants.medications.map((med) => (
          <div
            className="group hover:border-[1px] hover:border-gray-400"
            key={med.name}
          >
            <div className="text-body-md text-gray-800 bg-gray-20 group-hover:bg-gray-50 font-semibold p-2.5">
              <p>{med.name}{med.dose}</p>
              <p className="text-sm font-normal">{med.subname}</p>
            </div>

            {med.dosages.map((dose, index) => (
              <div
                key={index}
                onClick={() => {
                  onMedicineClick(dose.medicine, med?.subname);
                }}
                className="grid grid-cols-2 p-2.5 bg-white cursor-pointer border-b-[1px] border-b-gray-100 hover:bg-blue-100"
              >
                <p className="text-body-sm text-gray-800">{dose.age}</p>
                <div className="text-body-sm text-gray-800">
                  <p className="whitespace-pre-line">{dose.dosage}</p>
                  {dose?.maximumDosage && dose.maximumDosage()}
                  {dose.cps && (
                    <p className="flex">
                      CPS Reference: &nbsp;
                      <ReactSVG
                        src="/icons/information-dark.svg"
                        className="w-5"
                        data-tooltip-id={dose.cps}
                      />
                      <NewToolTip
                        id={dose.cps}
                        render={() => (
                          <div className="bg-gray-10 max-w-[300px] text-teal-300 text-body-sm p-2 whitespace-pre-line">
                            {dose.cps}
                          </div>
                        )}
                      />
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
    );
  };

  const renderContent = (type, activeButton) => {
    switch (type) {
      case "firstLineOralAntihistamines":
        return activeButton === "adult"
          ? renderAdultOralAntihistaminesContent()
          : renderPaediatricOralAntihistaminesContent();
      case "firstLineIntranasalCorticosteroids":
        return activeButton === "adult"
          ? renderAdultSteroidsContent()
          : renderPaediatricSteroidsContent();
      case "alternativeFirstLineCombination":
        return activeButton === "adult"
          ? renderAdultCombinationContent()
          : renderPaediatricCombinationContent();
      case "stepUpIntranasalCorticosteroids":
        return activeButton === "adult"
          ? renderAdultSteroidsContent()
          : renderPaediatricSteroidsContent();
      case "stepUpCombination":
        return activeButton === "adult"
          ? renderAdultCombinationContent()
          : renderPaediatricCombinationContent();
      case "addOnTherapyOralDecongestants":
        return activeButton === 'adult' ?
          renderAdultAddOnOralDecongestantContent() :
          renderPaediatricAddOnOralDecongestantContent()
      case "addOnTherapyIntranasalDecongestants":
        return activeButton === 'adult' ?
          renderAdultAddOnIntranasalDecongestantContent() :
          renderPaediatricAddOnIntranasalDecongestantContent()
      case "addOnTherapyOralAntihistamines":
        return activeButton === 'adult' ?
          renderAdultOralAntihistaminesContent() :
          renderPaediatricOralAntihistaminesContent()
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col flex-1 h-full overflow-y-auto">
      <div className="relative flex flex-col flex-1">
        {/* Header */}
        <div className="px-8 py-6 bg-gray-20">
          <div className="flex items-start justify-between space-x-3">
            <div className="flex space-x-1">
              <h2 className="font-bold text-gray-900 text-display-xs">
                {create ? "Add -" : "Update -"} {findTitle()}
              </h2>
            </div>
            <div className="flex items-center h-7">
              <button
                type="button"
                className="flex items-center justify-center p-1 transition-all rounded-full max-w-8 cursor-pointer right-4 top-3 bg-blue-200 hover:bg-REELTeal hover:text-white text-teal-300"
                onClick={() => onClose(false)}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="w-5 h-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="h-full overflow-y-auto">
          <div className="text-sm flex justify-end pr-8 pt-6">{currentStep} of 2</div>
          <div className="flex flex-col p-8 pt-0 h-[500px]">
            <div className="flex space-x-2 z-10">
              <ButtonComponent
                isActive={activeButton === "adult"}
                onClick={() => setActiveButton("adult")}
              >
                Adult Dose
              </ButtonComponent>
              <ButtonComponent
                isActive={activeButton === "paediatric"}
                onClick={() => setActiveButton("paediatric")}
              >
                Paediatric Dose
              </ButtonComponent>
            </div>
            <div className="flex flex-col border-gray-100 border-[1px] mt-[-1px] w-full">
              {renderContent(type, activeButton)}
            </div>
            <div className="bg-gray-20 my-4">
              <span onClick={() => {
                setShowPrescribingDetails(!showPrescribingDetails);
              }} className=" flex flex-row rounded-[10px] justify-between p-4">
                <p className="font-semibold text-lg">Prescribing Details</p>
                {showPrescribingDetails && <ChevronUpIcon className="w-4 h-4 text-teal-600" />}
                {!showPrescribingDetails && <ChevronDownIcon className="w-4 h-4 text-teal-600" />}
              </span>
              {showPrescribingDetails && (
                <div className="pb-4">
                  <ul className="pl-12 list-disc">
                    <li>
                      May prescribe sufficient quantity for the patient's allergy exposure
                    </li>
                    <li>
                      Ensure the patient is having adequate response before giving refills.
                    </li>
                    <li>
                      If the patient requires year-round therapy, as their exposures overlap, once follow up is complete, the pharmacist may provide refills for up to one year.
                    </li>
                    <li>
                      May prescribe if a patient presents requesting a prescription for <b>prophylaxis of anticipated exposure to an allergen</b>(without presenting with a current episode).
                    </li>
                  </ul>
                </div>
              )}

            </div>
          </div>

        </div>
        <div className="flex items-center justify-center py-6">
          <div className="flex items-center justify-center space-x-5">
            <Button
              className="min-w-[200px]"
              text="Cancel"
              type="primary-outline"
              onClick={() => onClose(false)}
            />
            <Button
              className="min-w-[200px]"
              text="Next"
              type="primary"
              onClick={() => onNext()}
            />
          </div>
        </div>
      </div>

      {/* Action buttons */}

    </div>
  );
};

export default InformationStep;
